import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot, faEye, faChartLine, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import styles from './HomePage.module.css';

const capabilities = [
  {
    icon: faRobot,
    accent: 'accentTeal',
    name: 'Discover',
    desc: 'Find evidence, themes, and opportunities.',
    to: '/discover',
  },
  {
    icon: faEye,
    accent: 'accentIndigo',
    name: 'Entity Intelligence',
    desc: 'Structured 360° domain intelligence on any entity.',
    to: '/entity-intelligence',
  },
  {
    icon: faChartLine,
    accent: 'accentAmber',
    name: 'Predictive Signals',
    desc: 'Turn diverse data into forward-looking signals.',
    to: '/predictive-signals',
  },
  {
    icon: faLightbulb,
    accent: 'accentPlum',
    name: 'Intelligence Studio',
    desc: 'Interconnected intelligence for ideas, charts, and reports.',
    to: '/intelligence-studio',
  },
];

const HomePage = () => {
  return (
    <div className={styles.page}>

      {/* ── Hero ── */}
      <section className={styles.hero}>
        <div className={styles.heroInner}>
          <p className={styles.eyebrow}>AI PREDICTIVE Intelligence</p>
          <h1 className={styles.headline}>
            Your edge in <span className={styles.headlineAccent}>every market</span>
          </h1>
          <p className={styles.subline}>
            Where AI meets domain intelligence, quantitative modeling, diverse data, and rich signals.
          </p>
          <div className={styles.statRow}>
            <span className={styles.statItem}><strong>20,000+</strong> companies</span>
            <span className={styles.statItem}><strong>200+</strong> global markets</span>
            <span className={styles.statItem}><strong>150+</strong> economies</span>
            <span className={styles.statItem}><strong>600+</strong> cryptos</span>
            <span className={styles.statItem}><strong>Live</strong> analysis</span>
          </div>
        </div>
      </section>

      {/* ── Capabilities ── */}
      <section className={styles.capabilities}>
        <div className={styles.capabilityGrid}>
          {capabilities.map((item) => (
            <Link key={item.to} to={item.to} className={`${styles.capabilityCard} ${styles[item.accent]}`}>
              <span className={styles.capabilityIcon}>
                <FontAwesomeIcon icon={item.icon} />
              </span>
              <span className={styles.capabilityName}>{item.name}</span>
              <span className={styles.capabilityDesc}>{item.desc}</span>
              <span className={styles.capabilityArrow}>→</span>
            </Link>
          ))}
        </div>
      </section>

    </div>
  );
};

export default HomePage;
